var _defs, _rect, _circle, _path, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _path2, _path3, _path4, _path5, _path6, _g, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreativestory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{font-size:22.44px;}.e,.f{font-family:Poppins-SemiBold, Poppins;}.g,.f,.h{fill:none;}.i{fill:#56504d;}.j{fill:#043730;}.k{fill:none;}.k,.l,.m,.n,.o,.h,.p{stroke-miterlimit:10;}.k,.l,.m,.n,.p{stroke:#272727;}.q{fill:#272727;}.r{fill:url(#b);}.l{fill:url(#d);}.m{fill:#ece4c6;}.n{fill:#d13e43;}.f{font-size:46.76px;}.o{fill:url(#c);stroke:#353535;stroke-width:2px;}.h{stroke:#1b1b1b;}.p{fill:#fdd752;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 252.86,
    y1: 74.46,
    x2: 252.86,
    y2: 427.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 259.34,
    y1: 25.4,
    x2: 259.34,
    y2: 484.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0054b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e1e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 228.4,
    y1: 188.2,
    x2: 262.54,
    y2: 188.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd71d"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 500,
    height: 500
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 252.86,
    cy: 250.9,
    r: 176.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M259.34,26.65c-124.44,0-225.32,100.88-225.32,225.32s100.88,225.32,225.32,225.32,225.32-100.88,225.32-225.32S383.79,26.65,259.34,26.65Zm0,380.93c-85.94,0-155.6-69.67-155.6-155.6S173.41,96.37,259.34,96.37s155.6,69.67,155.6,155.6-69.67,155.6-155.6,155.6Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(88.03 207.97) rotate(-70.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "K"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(103.67 169.16) rotate(-57.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(123.97 139.61) rotate(-45.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(149.77 114.76) rotate(-33.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(183.86 94.63) rotate(-22.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(204.99 86.51) rotate(-14.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(228.51 80.62) rotate(-4.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(266.67 79.18) rotate(5.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(288.86 81.1) rotate(16.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(332.93 95.82) rotate(32.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(371.88 123.22) rotate(44.11)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(389.18 140.05) rotate(55.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "f",
    transform: "translate(413.55 177.88) rotate(70.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(97.44 349.39) rotate(60.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(115.52 377.4) rotate(49.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(137.93 401.31) rotate(38.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(168.44 423.03) rotate(27.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(199.58 436.98) rotate(16.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(232.69 444.71) rotate(5.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(265.09 446.18) rotate(-4.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(296.32 442.06) rotate(-14.15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(324.83 433.19) rotate(-23.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(351.3 419.74) rotate(-32.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(372.38 404.79) rotate(-42.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(397.87 378.83) rotate(-54.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M350.83,199.11h-9.74v127.74s-13.09,3.81-44.03-5.51c-20.86-6.29-36.46,1.3-44.41,6.91-1.69,1.19-3.7,3.16-5.77,3.16h-.26c-2.07,0-4.08-1.97-5.77-3.16-7.95-5.61-23.55-13.19-44.41-6.91-30.93,9.32-44.03,5.51-44.03,5.51v-127.74h-9.74c-2.62,0-4.74,2.12-4.74,4.74v133.18c0,2.62,2.12,4.74,4.74,4.74h85.09c2.51,0,4.84,1.4,5.92,3.67,2.31,4.9,7.29,8.28,13.07,8.28,5.77,0,10.75-3.39,13.07-8.28,1.07-2.27,3.41-3.67,5.92-3.67h85.09c2.62,0,4.74-2.12,4.74-4.74V203.85c0-2.62-2.12-4.74-4.74-4.74h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M339.53,188.92c-6.4,.51-20.07,.32-41.72-6.1-31.39-9.32-51.06,11.86-51.06,11.86l-3.43,4.43v127.6l3.43,4.53v.17h.13c2.1,0,4.14-.66,5.86-1.85,8.07-5.61,23.9-13.19,45.07-6.91,31.39,9.32,46.01,5.51,46.01,5.51V192.83c0-2.29-1.98-4.1-4.29-3.91h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M329.65,178.92c-5.65,.51-17.72,.32-36.83-6.1-27.71-9.32-45.07,11.86-45.07,11.86l-3.02,4.43v127.6l3.02,4.53v.17h.12c1.85,0,3.65-.66,5.17-1.85,7.12-5.61,21.1-13.19,39.78-6.91,27.71,9.32,40.62,5.51,40.62,5.51V182.83c0-2.29-1.75-4.1-3.79-3.91h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M159.82,188.92c6.4,.51,20.07,.32,41.72-6.1,31.39-9.32,51.06,11.86,51.06,11.86v136.73h-.13c-2.1,0-4.14-.66-5.86-1.85-8.07-5.61-23.9-13.19-45.07-6.91-31.39,9.32-46.01,5.51-46.01,5.51V192.83c0-2.29,1.98-4.1,4.29-3.91h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M165.86,178.92c5.65,.51,17.72,.32,36.83-6.1,27.71-9.32,45.07,11.86,45.07,11.86v136.73h-.12c-1.85,0-3.65-.66-5.17-1.85-7.12-5.61-21.1-13.19-39.78-6.91-27.71,9.32-40.62,5.51-40.62,5.51V182.83c0-2.29,1.75-4.1,3.79-3.91h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "p",
    cx: 253.93,
    cy: 173.5,
    rx: 8.99,
    ry: 10.89,
    transform: "translate(-18.38 316.43) rotate(-62.04)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M243.93,169.64l-15.54,28.11c3.91,8.9,10.44,10.31,19.97,8.43l14.17-26.39s-1.6-4.84-7.9-8.15c-5.59-2.93-10.7-2.01-10.7-2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M248.37,206.18l-23.82,23.27,3.85-31.71s4.86-2.25,5.68,4.1c0,0,5.32-3.28,5.94,3.07,0,0,4.5-2.87,4.5,1.84,0,0,2.54-1.92,3.85-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M226,216.7l-1.45,12.75,10.41-9.77c-2.72,.07-5.91-.07-8.96-2.99Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 234.07,
    y1: 201.84,
    x2: 250.2,
    y2: 172.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 241.24,
    y1: 204.3,
    x2: 256.76,
    y2: 175.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M264.94,176.91l1.51-2.72c4.27-7.7,3.34-16.37-2.07-19.37-5.41-3-13.25,.82-17.51,8.52l-1.51,2.72,19.58,10.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M242.96,170.91l2.58-4.34s14.09-.2,19.36,9.73l-2.57,3.8s-7.23-9.19-19.37-9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M244.81,168.53s13.52,.92,18.95,9.59"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M220.8,229.86c-3.34,3.21-6.97,6.6-11.67,7.64-4.58,.69-6.35-3.23-5.09-7.09,1.26-4.33,4.12-7.35,6.56-10.61,.16-.24,.12-.37,.15-.27-.05,.22,.18,.47,.14,.4-1.55-.65-3.44-.48-5.4-.39-3.45,.19-6.97,.8-10.44,1.53-3.47,.7-6.94,1.64-10.16,2.84-1.75,.66-3.71,1.34-5.73,1.38-7.89,.21-10.59-6.88-4.63-12.06-1.01,1.51-1.85,3.16-1.97,4.83-.34,3.6,3.16,5.19,6.39,4.62,1.67-.29,3.14-.85,4.67-1.62,3.4-1.67,6.95-2.71,10.58-3.68,3.6-.88,7.25-1.55,11.04-1.83,2.4-.06,5.55-.29,7.91,1.23,1.64,1.08,1.83,3.42,.77,4.95-1.34,1.96-3.13,3.44-4.43,5.36-1.48,2.06-5.47,8.14-.58,8.14,4.3-.5,8.19-3.19,11.9-5.37h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativestory);
export default __webpack_public_path__ + "static/media/creativestory.b8b75879915f7e71d514925cf148a395.svg";
export { ForwardRef as ReactComponent };